import prop from 'ramda/src/prop'
import curry from 'ramda/src/curry'
import pipe from 'ramda/src/pipe'
import profileSelector from 'root/src/client/logic/app/selectors/profileSelector'

export default curry((propName, state) => pipe(profileSelector, prop(propName))(state))
